@if (mitLinkGeschaeft) {
  <cap-link [params]="[item.id.id]" [target]="navTargets.NAV_GRUNDBUCHGESCHAEFT">
    <ng-template [ngTemplateOutlet]="value"></ng-template>
  </cap-link>
} @else {
  {{ item | kompaktGrundbuchgeschaeft }}
}
@if (dokulink && formatConfigService.settingsConfig$ | async; as settingsConfig) {
  @if (settingsConfig.isCmisConfigured) {
    <cap-cmis
      [target]="{ itemType: 'Geschaeft', id: item.timePoint?.id.id, tooltipParam: item.timePoint | kompaktGrundbuchgeschaeft }"></cap-cmis>
  } @else if (settingsConfig.isDokuLinkGeschaeftConfigured) {
    <cap-dokulink [item]="dokuLinkBuilderFactory.create('GBGESCHAEFT').setEntry(item).build()"></cap-dokulink>
  }
}
<ng-template #value>
  {{ item | kompaktGrundbuchgeschaeft }}
</ng-template>
